module.exports = __webpack_public_path__ + "frame-59ed99bf/lebenslauf-logo-dark-0d9ea65604f56d868dedd80b950c78b0.svg";